import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/process-active.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-29d7124e")

_pushScopeId("data-v-29d7124e")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Název", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "discount-line" }
const _hoisted_7 = { class: "discount column-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Kód kódu", -1)
const _hoisted_9 = { class: "value" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Vygenerováno", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "discount column-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Platnost (Od)", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Platnost (Do)", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "discount column-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Celkem použití", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Použití na uživatele", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "discount column-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Hodnota/Typ", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Entita", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "discount column-5" }
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Stav", -1)
const _hoisted_32 = {
  key: 0,
  class: "value"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  class: "process",
  src: _imports_0,
  alt: "Aktivní"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Aktivní")
const _hoisted_35 = {
  key: 1,
  class: "value"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Použití (MOCK)", -1)
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "discount column-6" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.promocodeItem.promocodeId) + "# " + _toDisplayString(_ctx.promocodeItem.name), 1)
      ])
    ]),
    _hoisted_5,
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("p", _hoisted_9, _toDisplayString(_ctx.promocodeItem.code !== '' ? _ctx.promocodeItem.code : _ctx.promocodeItem.codeMask), 1),
        _hoisted_10,
        _createVNode("p", _hoisted_11, _toDisplayString(_ctx.promocodeItem.codesCount), 1)
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("p", _hoisted_14, _toDisplayString(_ctx.promocodeItem.timeValidityFrom), 1),
        _hoisted_15,
        _hoisted_16,
        _createVNode("p", _hoisted_17, _toDisplayString(_ctx.promocodeItem.timeValidityTo), 1)
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.promocodeItem.promocodeTotalUseLimit), 1),
        _hoisted_21,
        _hoisted_22,
        _createVNode("p", _hoisted_23, _toDisplayString(_ctx.promocodeItem.promocodeUsedByUserLimit), 1)
      ]),
      _createVNode("div", _hoisted_24, [
        _hoisted_25,
        _createVNode("p", _hoisted_26, _toDisplayString(_ctx.getApplierValue(_ctx.appliers, _ctx.promocodeItem.applierId, _ctx.promocodeItem.discount, _ctx.promocodeItem.currency, _ctx.promocodeItem.finalPrice)) + " / " + _toDisplayString(_ctx.getApplierName(_ctx.appliers, _ctx.promocodeItem.applierId)), 1),
        _hoisted_27,
        _hoisted_28,
        _createVNode("p", _hoisted_29, _toDisplayString(_ctx.promocodeItem.consignCountries.toString().toUpperCase()), 1)
      ]),
      _createVNode("div", _hoisted_30, [
        _hoisted_31,
        (_ctx.promocodeItem.status === 'active')
          ? (_openBlock(), _createBlock("p", _hoisted_32, [
              _hoisted_33,
              _hoisted_34
            ]))
          : _createCommentVNode("", true),
        (_ctx.promocodeItem.status === 'inactive')
          ? (_openBlock(), _createBlock("p", _hoisted_35, "Neaktivní"))
          : _createCommentVNode("", true),
        _hoisted_36,
        _hoisted_37,
        _createVNode("p", _hoisted_38, _toDisplayString(_ctx.promocodeItem.promocodeTotalUseLimit), 1)
      ]),
      _createVNode("div", _hoisted_39, [
        _createVNode("button", {
          class: "button-edit",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editDiscount(_ctx.index, _ctx.promocodeItem)))
        }, "Upravit"),
        _hoisted_40,
        _createVNode("button", {
          class: "button-delete",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeDiscount(_ctx.index, _ctx.promocodeItem)))
        }, "Smazat")
      ])
    ])
  ], 64))
})